import axios from "axios";

// let url = "http://127.0.0.1:8000/api";

// Live
// let url = "https://backend.orderwalabd.com/public/api";

// App Test
let url = "https://erpdemobackend.limerickbd.com/public/api";

// Live Development
// let url = "https://orderwalabd.com/backend-development/public/api";

export default axios.create({
  url: url,
  baseURL: url,
  headers: {
    Accept: "application/json",
    // "Content-Type": "multipart/form-data",
    // Accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Access-Control-Allow-Credentials": true,
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
  },
});
